import { render } from "./ScheduledMaintenance.vue?vue&type=template&id=36dc36e7"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__